import { CollectDebugInfoFn } from '@/services/DebugInfoCollector/types';

export const collectTimestamp: CollectDebugInfoFn = () => ({
  timestamp: Date.now(),
});
